import React from 'react';
import { Navigate } from 'react-router-dom';
import { AuthLoader } from './ui';
import { useAuth } from '../contexts/AuthContext';

export default function RootRedirect() {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return <AuthLoader />;
  return <Navigate to={isAuthenticated ? '/admin/hub' : '/auth/sign-in'} replace />;
}
